import { render } from "./IconTrekRange.vue?vue&type=template&id=71d8462e"
import script from "./IconTrekRange.vue?vue&type=script&lang=js"
export * from "./IconTrekRange.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__